import React from 'react';
import { lazy } from 'react-loosely-lazy';
import Blanket from '@atlaskit/blanket';
import { SOFTWARE_CYCLE_TIME_REPORT_ISSUE } from '@atlassian/jira-common-constants/src/analytics-sources';
import type { OnIssueKeyChangeFn } from '@atlassian/jira-issue-context-service';
import type ModalIssueAppType from '@atlassian/jira-issue-view/src/views/issue-details/modal-issue-app';
import Placeholder from '@atlassian/jira-placeholder';
import type { IssueKey } from '@atlassian/jira-shared-types';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const ModalIssueApp = lazy<typeof ModalIssueAppType>(
	() =>
		import(
			/* webpackChunkName: "async-cycle-time-report-issue-modal-issue-app" */ '@atlassian/jira-issue-view/src/views/issue-details/modal-issue-app'
		),
);
type Props = {
	issueKey: IssueKey;
	onIssueKeyChange: OnIssueKeyChangeFn;
	onClose: () => void;
};

const IssueModal = ({ issueKey, onIssueKeyChange, onClose }: Props) => (
	<Placeholder name="cycle-time-report-issue-modal-issue-app" fallback={<Blanket />}>
		<ModalIssueApp
			analyticsSource={SOFTWARE_CYCLE_TIME_REPORT_ISSUE}
			issueKey={issueKey}
			onClose={onClose}
			onIssueKeyChange={onIssueKeyChange}
		/>
	</Placeholder>
);

export default IssueModal;
